const prefix = '/ai-reviews';

export const ApiAiReviewsUrls = {
  retrieve: `${prefix}/:id`,
  destroy: `${prefix}/:id`,
  public: `${prefix}/:id/public`,
  togglePublicSharing: `${prefix}/:id/toggle-public-sharing`,
  updateSharedEmails: `${prefix}/:id/update-shared-emails`,
  fastReview: `${prefix}/fast-review`,
  myReviews: `${prefix}/my-reviews`,
  lastReview: `${prefix}/last-review`,
  stats: `${prefix}/stats`,
  submitFeedback: `${prefix}/:id/submit-feedback`,
  cancel: `${prefix}/:id/cancel`,
  restart: `${prefix}/:id/restart`,
  downloadPresentation: `${prefix}/:id/download-presentation`,
};
